
export const skills = [
  {
    skillName: 'C#',
    image: require('./images/c-sharp.svg').default,
  },
  {
    skillName: 'Python',
    image: require('./images/python.svg').default,
  },
  {
    skillName: '.NET',
    image: require('./images/net.svg').default,
  },
  {
    skillName: 'GraphQL',
    image: require('./images/graphql.svg').default,
  },
  {
    skillName: 'Git',
    image: require('./images/git.svg').default,
  },
  {
    skillName: 'MySQL',
    image: require('./images/mysql.svg').default,
  },
  {
    skillName: 'SQL Server',
    image: require('./images/microsoft-sql-server.svg').default,
  },
  {
    skillName: 'Azure',
    image: require('./images/microsoft.svg').default,
  },
  {
    skillName: 'Angular',
    image: require('./images/angular.svg').default,
  },
  {
    skillName: 'React',
    image: require('./images/react.svg').default,
  },
];


